import { useRef } from 'react';
import { useStateInRef } from '../../../utils/useStateInRef';
/**
 * The open run and its pages, tracked at mutation time rather than in state: a surface joining the
 * drawer reads the run inside the same commit that opened it, and a caller's page id may be reused
 * across pages, so it is mapped to the entry instead of becoming the entry's id.
 */ export function useSheetRunRegistry() {
    const openRun = useRef(null);
    const entryIdByCallerPageId = useRef(new Map());
    function forgetEntries(entryIds) {
        entryIds.forEach((entryId)=>{
            [
                ...entryIdByCallerPageId.current
            ].forEach((param)=>{
                let [callerPageId, mapped] = param;
                if (mapped === entryId) entryIdByCallerPageId.current.delete(callerPageId);
            });
        });
        const run = openRun.current;
        if (!run) return;
        entryIds.forEach((entryId)=>run.entryIds.delete(entryId));
        if (run.entryIds.size === 0) openRun.current = null;
    }
    return {
        readOpenRunId: ()=>{
            var _ref;
            var _openRun_current;
            return (_ref = (_openRun_current = openRun.current) === null || _openRun_current === void 0 ? void 0 : _openRun_current.id) !== null && _ref !== void 0 ? _ref : null;
        },
        joinOrStartRun: (runId, entryId)=>{
            const run = openRun.current;
            openRun.current = run && run.id === runId ? {
                id: runId,
                entryIds: run.entryIds.add(entryId)
            } : {
                id: runId,
                entryIds: new Set([
                    entryId
                ])
            };
        },
        rememberCallerPageId: (callerPageId, entryId)=>entryIdByCallerPageId.current.set(callerPageId, entryId),
        entryIdForCallerPageId: (callerPageId)=>entryIdByCallerPageId.current.get(callerPageId),
        lastEntryIdOfOpenRun: ()=>{
            const run = openRun.current;
            return run == null ? undefined : [
                ...run.entryIds
            ][run.entryIds.size - 1];
        },
        forgetEntries,
        getForgetEntries: useStateInRef(forgetEntries),
        closeOpenRun: ()=>{
            var _ref;
            const run = openRun.current;
            openRun.current = null;
            return (_ref = run === null || run === void 0 ? void 0 : run.id) !== null && _ref !== void 0 ? _ref : null;
        }
    };
}
